import { render, staticRenderFns } from "./postsalelistODM.vue?vue&type=template&id=a26e202a&"
import script from "./postsalelistODM.vue?vue&type=script&lang=ts&"
export * from "./postsalelistODM.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports